import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=153ef6f8&scoped=true&"
import script from "./sticky.vue?vue&type=script&lang=js&"
export * from "./sticky.vue?vue&type=script&lang=js&"
import style0 from "./sticky.vue?vue&type=style&index=0&id=153ef6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ef6f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153ef6f8')) {
      api.createRecord('153ef6f8', component.options)
    } else {
      api.reload('153ef6f8', component.options)
    }
    module.hot.accept("./sticky.vue?vue&type=template&id=153ef6f8&scoped=true&", function () {
      api.rerender('153ef6f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/sticky.vue"
export default component.exports